import script from "./DateRangePicker2.vue?vue&type=script&setup=true&lang=js"
export * from "./DateRangePicker2.vue?vue&type=script&setup=true&lang=js"

import "./DateRangePicker2.vue?vue&type=style&index=0&id=944bdb78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-944bdb78"]])

export default __exports__